import { ReactNode } from "react";
import { inputsGroup } from "./style.css";

export function InputsGroup(props: { children: ReactNode }) {
  return <div className={inputsGroup}>{props.children}</div>;
}
